import apiInstance from "services/api/api";
import { IPaymentMethod } from "shared/interfaces/Order.interface";

export default (restaurantId: string): Promise<IPaymentMethod[]> =>
  apiInstance
    .get(`/bms/payment-methods/${restaurantId}`)
    .then((res) => res.data.data);
